import React from 'react';

interface NextNumberProps {
    /** The number to display inside the icon (e.g. seconds to skip) */
    number: number | string;
    /** Optional class applied to the `<svg>` for styling */
    className?: string;
}

const NextNumber: React.FC<NextNumberProps> = ({ number, className }) => (
    <svg
        className={className}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Circle + arrow */}
        <path
            d="M10.8334 4.87484L13 2.1665C7.01677 2.1665 2.16669 7.01659 2.16669 12.9998C2.16669 18.9831 7.01677 23.8332 13 23.8332C18.9833 23.8332 23.8334 18.9831 23.8334 12.9998C23.8334 8.55817 21.1597 4.73942 17.3334 3.06784"
            stroke="currentColor"
            strokeWidth="1.625"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.5"
        />
        {/* The number label */}
        <text
            x="13"
            y="13"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="currentColor"
            fontSize="10"
            fontWeight="1000"
        >
            {number}
        </text>
    </svg>
);

export default NextNumber;
